module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAMCAYAAAAK/x/DAAAA5UlEQVQ4T72UMQuCQBzF34uW9gLrc+XYHGRUUEPfoK0kMGhutM+Vgu1t/kPpRKtDz0yXw+Pu3o/fPSVez8iVeQwcAHTVXEtjTGATrJhkgyp06MpWgF1LEIUYEutgyX0BKHmxXLFJeCIYtAFGIhKBE67oq7zMkJqwjjKg4CSC8T+hSFyFmIULRvmcD6AM7E+2vlmpBJReYcO2dFYqAzVlq8yKMZCyhRgeANuwWz46cN67ojtD2yHdhqpfoomVWobym5JuldgysvIzkK5bda00BpQcNDpLXx6YpH/ZHi63Ke+GHSssfwKHR2gN9S3YTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_arrows_down.png
// module id = r7N9
// module chunks = 96